
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Box, Button } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

import ModalLayout, {
  closeTimeoutMS,
  defaultModalStyles,
} from '@src/components/layout/modalLayout';

import TeacherVideoModalPresenter from './teacherVideoModalPresenter';

const TeacherVideoModal = () => {
  const { t } = useTranslation();
  const [modalVm, setModalVm] = useState({});
  const teacherVideoModalPresenter = new TeacherVideoModalPresenter();

  useEffect(() => {
    const updateView = (modalVm) => {
      setModalVm(modalVm);
    };
    teacherVideoModalPresenter.loadModalState(updateView);
    return updateView;
  }, []);

  return (
    <ReactModal
      isOpen={modalVm.isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      onRequestClose={() => {
        teacherVideoModalPresenter.toggleModal();
      }}
      closeTimeoutMS={closeTimeoutMS}
      style={defaultModalStyles}
    >
      <ModalLayout>
        <Box py={4}>
          <Box
            bg="white"
            sx={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0px 10px 30px #0000001A',
              minWidth: '70vw',
            }}
          >
            <Box
              className="checkout-header"
              sx={{ padding: '30px', textAlign: 'center' }}
            >
              <Themed.h3 sx={{ margin: 0 }}>
                {t('introVideoModalTitle')}
              </Themed.h3>
              <Button
                variant="empty"
                onClick={() => {
                  teacherVideoModalPresenter.toggleModal();
                }}
                sx={{
                  padding: '8px',
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  fontSize: '14px',
                  color: 'label',
                }}
              >
                {t('close')}
              </Button>
            </Box>

            <Box
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '10px',
                width: '100%',
                paddingTop:
                  '56.25%' /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */,
              }}
            >
              <iframe
                loading="lazy"
                className="responsive-iframe"
                width="560"
                height="315"
                src={modalVm.videoUrl}
                title=""
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                onError="alert('Failed')"
              ></iframe>
            </Box>
          </Box>
        </Box>
      </ModalLayout>
    </ReactModal>
  );
};

export default TeacherVideoModal;
